import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatNull, formatDate } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';
import Loading from '../Loading';
import WarningPanel from '../WarningPanel';
import ViewFileById from '../ViewFileById';

import Modal from '../Modal';
import EditAdministrativeResponsibility from './Components/EditAdministrativeResponsibility';

import ButtonWithConfirmation from '../ButtonWithConfirmation';

import IconContainer from '../IconContainer';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

const AdministrativeResponsibility = ({ userId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { openTimeModal } = useTimeModal();

  const [cases, setCases] = React.useState([]);
  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get(`/api/get-user-administrative-responsibility?id=${userId}`)
    .then((response) => {
      setWarning('');
      setCases(response.data);
    })
    .catch((error) => {
      console.error(error);
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload, userId]);

  const deleteEntry = (id) => {
    const token = localStorage.getItem('token');

    axios.delete('/api/delete-administrative-responsibility', {
      data: { id },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then((response) => {
      openTimeModal('Запись удалена', 'success');
      setReload(true);
    })
    .catch((error) => {
      openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const [isEditModal, setIsEditModal] = React.useState(false);

  const [currentId, setCurrentId] = React.useState('');
  const [currentAction, setCurrentAction] = React.useState('');

  const openSuperModal = (id, action) => {
    setCurrentId(id);
    setCurrentAction(action);
    setIsEditModal(true);
  };


  return (
    <>
      <Modal isOpen={isEditModal} closeModal={() => setIsEditModal(false)}>
          <EditAdministrativeResponsibility id={currentId} action={currentAction} userId={userId} onSuccess={() => setReload(true)} />
      </Modal>

      <div className='tableContainer'>
        <div className='tableHeaderWrapper'>
          <div className='tableStatus'>
              <button type='button' className='secondaryButton' onClick={() => {openSuperModal('', 'add')}}>
                <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                  <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                </svg>
                Добавить сведения об административной ответственности
              </button>
              <a className='lastUpdateWrapper'>
                  {loading ? 
                      <Loading type='inline' /> 
                  : 
                      <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                  }
              </a>
          </div>
          <div className='tableHeader' style={{ gridTemplateColumns: '12fr 14fr 12fr 25fr 12fr 6fr' }}>
              <div>Суд</div>
              <div>Номер дела</div>
              <div>Дата привлечения</div>
              <div>Мера ответственности</div>
              <div>Скан</div>
              <div></div>
          </div>
        </div>
        {loading ? <LoadingLines /> 
        : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
        : cases.map((caseItem) => (
            <div 
              className='tableRow nonActive' 
              style={{ gridTemplateColumns: '12fr 14fr 12fr 25fr 12fr 6fr' }}
              key={caseItem.id} 
            >
              <div>{formatNull(caseItem.court)}</div>
              <div>
                <a
                  className='aWithLink'
                  onClick={() => {navigate(`/case/${caseItem.case_id}`, { state: { from: location.pathname + location.search + location.hash }})}}
                >
                  {formatNull(caseItem.case_number)}
                </a>
              </div>
              <div>{formatDate(caseItem.attraction_date)}</div>
              <div>{formatNull(caseItem.measure)}</div>
              <div>
                {caseItem.file_id ? 
                  <ViewFileById fileId={caseItem.file_id} />
                :
                  <p className='description'>Не был прикреплен</p>
                }
              </div>
              <div style={{alignItems: 'end'}}>
                  <div className='horizontalCell'>
                    <ButtonWithConfirmation 
                        entryFunc={() => {deleteEntry(caseItem.id)}} 
                        Icon={TrashIcon} 
                        IconSize={17}
                        buttonName='Удалить' 
                        color='red' 
                    />
                  </div>
              </div>
            </div>
        ))}
      </div>
    </>
  )
}

export default AdministrativeResponsibility;